import React from "react";
import { Box, Skeleton } from "@mui/material";

const FinancialsPlansSkeleton = () => {
  return (
    <Box sx={{ padding: "20px" }}>
      {/* 🔹 Page Title Skeleton */}
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Skeleton variant="circular" width={50} height={50} animation="wave" />
        <Box>
          <Skeleton variant="text" width={180} height={30} animation="wave" />
          <Skeleton variant="text" width={300} height={20} animation="wave" />
        </Box>
      </Box>

      {/* 🔹 Filter / Search Section Skeleton */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}
        mb={4}
      >
        <Skeleton variant="rectangular" width={200} height={40} animation="wave" />
        <Skeleton variant="rectangular" width={180} height={40} animation="wave" />
        <Skeleton variant="rectangular" width={160} height={40} animation="wave" />
        <Skeleton variant="rectangular" width={100} height={40} animation="wave" />
      </Box>

      {/* 🔹 Subscription Plans Skeleton (cards) */}
      <Box display="flex" flexWrap="wrap" gap={3} mb={5}>
        {[...Array(3)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width="31%"
            height={150}
            animation="wave"
            sx={{ borderRadius: "12px" }}
          />
        ))}
      </Box>

      {/* 🔹 Revenue Analytics / Chart Placeholder */}
      <Box mb={5}>
        <Skeleton variant="text" width={200} height={25} animation="wave" />
        <Skeleton
          variant="rectangular"
          height={280}
          animation="wave"
          sx={{ borderRadius: "12px", mt: 1 }}
        />
      </Box>

      {/* 🔹 Subscribed Users List (table style) */}
      <Box>
        <Skeleton variant="text" width={180} height={25} animation="wave" sx={{ mb: 2 }} />
        {[...Array(6)].map((_, i) => (
          <Box
            key={i}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              padding: "10px 16px",
              mb: 1,
            }}
          >
            <Skeleton variant="text" width="20%" height={20} animation="wave" />
            <Skeleton variant="text" width="15%" height={20} animation="wave" />
            <Skeleton variant="text" width="10%" height={20} animation="wave" />
            <Skeleton variant="text" width="15%" height={20} animation="wave" />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FinancialsPlansSkeleton;
